(function(){
    "use strict";
    
    angular
        .module("app")
        .component("cartProductListItem", { // cart-product-list-item
            bindings: {
				item: "<"
            },
            templateUrl: "src/app/cart/cartProductListItem.html",
            controller: controller
        });

    function controller(session, toast, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;
	    $ctrl.ui = {
	        busy: false
	    };
        $ctrl.session = session;
        $ctrl.qty = 0;
        $ctrl.product = null;
        $ctrl.kitCheck = false;


        $ctrl.$onChanges = changes => {
            $ctrl.qty = changes.item.currentValue.quantity;
        };

        $ctrl.$onInit = () => {
            $ctrl.product = session.products.allProducts.find(p => $ctrl.item.item_id === p.item_id && $ctrl.item.sale_UOM === p.sale_UOM);
            $ctrl.kitCheck = $ctrl.item.kit_check_surcharge != null;
        };

        $ctrl.hasBundleIncentive = () => {
            $ctrl.item.incentives.some(i => i.incentive_type_Code === "BND");
        };

		$ctrl.showUpdate = () => {

			// show update button on ui 
            var showUpdateButton = $ctrl.item && $ctrl.qty !== undefined && $ctrl.qty !== $ctrl.item.quantity;

            if ($ctrl.item.max_sale_qty)
                showUpdateButton = showUpdateButton && $ctrl.qty <= $ctrl.item.max_sale_qty;

			// flag item as being updated
			const isUpdating = $ctrl.qty != $ctrl.item.quantity;
		    $ctrl.item.isUpdating = isUpdating;
			
			return showUpdateButton;
		};

        $ctrl.showDiscountPendingBudesonide = () => {
            //if ($ctrl.item.incentives.length > 0)
            //    return false;

            //if ($ctrl.item.item_id === 287 || $ctrl.item.item_id === 285)
            //    return true;

            return false;
        };

        $ctrl.showDiscountPendingNotBudesonide = () => {
            //if ($ctrl.item.incentives.length > 0)
            //    return false;

            //if ($ctrl.item.item_id === 287 || $ctrl.item.item_id === 285)
            //    return false;

            //return session.incentives.some(inc => inc.items.some(i => i.item_id === $ctrl.item.item_id));
            return false;
        };

        //$ctrl.calcOrigPrice = () => {
        //    var price = $ctrl.item.sale_UOM_price;
        //    $ctrl.item.incentives.forEach(inc => price += inc.discount_amount);
        //    return price;
        //};

        $ctrl.calcDiscountApplied = () => {
            var price = 0;
            $ctrl.item.incentives.filter(inc => inc.display_in_line_item_level_bit).forEach(inc => price += inc.discount_amount);
            return price;
        };

        $ctrl.updateClicked = () => {
            return updateItem();
        };

        $ctrl.kitCheckChanged = () => {
            return updateItem();
        };

        function updateItem() {
            $ctrl.ui.busy = true;
            const kit_check_surcharge = $ctrl.kitCheck ? $ctrl.product.kit_check_surcharge : null;
            if ($ctrl.qty == 0) {
                return deleteItem();
            } else {
                return session
                    .cart
                    .updateItem($ctrl.item.item_id, $ctrl.qty, $ctrl.item.sale_UOM, kit_check_surcharge)
                    .then(() => {
                        $ctrl.item.isUpdating = false;
                    })
                    .catch(toast.errorHandler)
                    .finally(() => { $ctrl.ui.busy = false; });
            }
        }

        $ctrl.deleteClicked = () => {
            return deleteItem();
        };

        $ctrl.calcPrimaryPackQty = () => {
            const multiplier = $ctrl.item.unit_of_measure === $ctrl.item.sale_UOM ? 1 : $ctrl.item.units_per_case;
            return $ctrl.item.vials_per_unit * multiplier * $ctrl.qty;
	    };

        function deleteItem() {
            $ctrl.ui.busy = true;
			return session
				.cart
				.removeItem($ctrl.item.item_id, $ctrl.item.sale_UOM)
                .catch(toast.errorHandler)
                .finally(() => { $ctrl.ui.busy = false; });
        }

        $ctrl.isQuantityGreaterThanMaxQuantity = () => {
            return $ctrl.item.max_sale_qty && $ctrl.qty > $ctrl.item.max_sale_qty;
        };

        $ctrl.getMaxQuantityErrorMessage = () => {
            return `Maximum Quantity is ${$ctrl.item.max_sale_qty} ${$ctrl.item.sale_UOM_desc}${$ctrl.item.max_sale_qty === 1 ? "" : "s"}.`;
        }
    }
    controller.$inject = ["sessionService", "stToastFactory", "CART_TYPE_CODE"];
    
})()